<!--
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-04-16 02:03:08
 * @FilePath: \hippo-web-admin\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app" :dir="$store.state.lang === 'ar' ? 'rtl' : 'ltr'">
    <router-view :key="$store.state.lang" />
  </div>
</template>

<script>
  export default {
    name: 'App'
  };
</script>

<style>
  /* 全局 RTL 样式支持 */
  html[dir='rtl'] {
    direction: rtl;
    text-align: right;
  }

  html[dir='ltr'] {
    direction: ltr;
    text-align: left;
  }
</style>
